export var NavigationEventItemClickLocationEnum;
(function (NavigationEventItemClickLocationEnum) {
    NavigationEventItemClickLocationEnum["SIDEBAR"] = "sidebar";
})(NavigationEventItemClickLocationEnum || (NavigationEventItemClickLocationEnum = {}));
export var CreateVoucherPageLoadLocationEnum;
(function (CreateVoucherPageLoadLocationEnum) {
    CreateVoucherPageLoadLocationEnum["HOME"] = "home";
    CreateVoucherPageLoadLocationEnum["HOME_ONBOARDING"] = "home_onboarding";
    CreateVoucherPageLoadLocationEnum["VOUCHER_DETAIL_PAGE"] = "voucher_detail_page";
    CreateVoucherPageLoadLocationEnum["VOUCHER_HOME"] = "voucher_home";
})(CreateVoucherPageLoadLocationEnum || (CreateVoucherPageLoadLocationEnum = {}));
// different locations where voucher can be deleted/edited/shared
export var VoucherLocationEnum;
(function (VoucherLocationEnum) {
    VoucherLocationEnum["VOUCHER_DETAIL_PAGE"] = "VOUCHER_DETAIL_PAGE";
    VoucherLocationEnum["VOUCHER_DETAIL_PAGE_EMPTY"] = "VOUCHER_DETAIL_PAGE_EMPTY";
    VoucherLocationEnum["VOUCHER_HOME"] = "VOUCHER_HOME";
    VoucherLocationEnum["DIRECT_URL"] = "DIRECT_URL";
})(VoucherLocationEnum || (VoucherLocationEnum = {}));
export var VoucherPaymentType;
(function (VoucherPaymentType) {
    VoucherPaymentType["INVOICING"] = "invoicing";
    VoucherPaymentType["CREDIT_CARD"] = "credit_card";
})(VoucherPaymentType || (VoucherPaymentType = {}));
export var VoucherFormType;
(function (VoucherFormType) {
    VoucherFormType["CREATE"] = "create";
    VoucherFormType["EDIT"] = "edit";
})(VoucherFormType || (VoucherFormType = {}));
export var AddPaymentView;
(function (AddPaymentView) {
    AddPaymentView["DEFAULT"] = "add-card-modal";
    AddPaymentView["VOUCHER_HOME"] = "voucher_home";
    AddPaymentView["VOUCHER_SHARE_MODAL"] = "voucher_share_modal";
    AddPaymentView["VOUCHER_FORM"] = "voucher_form";
})(AddPaymentView || (AddPaymentView = {}));
